<template>
  <div class="linkNoLimit">
    <img src="../../assets/images/linkEmpty.png" alt="" class="linkImg">
    <span>链接已失效</span>
  </div>
</template>

<script>
export default {
name: "index"
}
</script>

<style scoped lang="less">
.linkNoLimit{
  position: fixed;
  top: 28%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 30px;
  color: #999999;
  text-align: center;
  .linkImg{
    width: 400px;
  }
}
</style>
